import Dashboard from "../views/Dashboard";
import UserLayout from "../Layouts/UserLayout";
import LoginLayout from "../Layouts/LoginLayout";
import PasswordReset from "../views/PasswordReset";
import Vehicle from "../views/Vehicle";
import Trip from "../views/Trip";
import CarHealth from "../views/CarHealth";
import Refill from "../views/Refill";
import TripDetail from "../views/TripDetail";
import DeleteAccount from '../views/DeleteAccount'

const userRoutes = [
    {
        path: '/dashboard',
        name: Dashboard,
        component: Dashboard,
        meta: {
            layout: UserLayout,
            role: 'authenticated',
            title: 'Dashboard'
        }
    },
    {
        path: '/reset-password',
        name: 'PasswordReset',
        component: PasswordReset,
        meta: {
            layout: LoginLayout,
            role: 'authenticated',
            title: 'Reset Password'
        }
    },
    {
        path: '/vehicle',
        name: Vehicle,
        component: Vehicle,
        meta: {
            layout: UserLayout,
            role: 'authenticated',
            title: 'Vehicle'
        }
    },
    {
        path: '/vehicle/:id/trip',
        name: Trip,
        component: Trip,
        meta: {
            layout: UserLayout,
            role: 'authenticated',
            title: 'Trip'
        }
    },
    {
        path: '/vehicle/:id/health',
        name: CarHealth,
        component: CarHealth,
        meta: {
            layout: UserLayout,
            role: 'authenticated',
            title: 'Car Health'
        }
    },
    {
        path: '/vehicle/:id/refill',
        name: Refill,
        component: Refill,
        meta: {
            layout: UserLayout,
            role: 'authenticated',
            title: 'Refill'
        }
    },
    {
        path: '/trip/:id/tripdetail',
        name: TripDetail,
        component: TripDetail,
        meta: {
            layout: UserLayout,
            role: 'authenticated',
            title: 'Trip Detail'
        }
    },
    {
        path: '/deleteaccount',
        name: DeleteAccount,
        component: DeleteAccount,
        meta: {
            layout: UserLayout,
            role: 'authenticated',
            title: 'Delete Account'
        }
    }
];

export default userRoutes;
